import React from "react";
import { Button } from "react-bootstrap";
import styled, { css } from "styled-components";

import * as colors from "../../../../../assets/_base/colors";

export const MainButton = styled(Button)`
    min-width: 150px;
    border-radius: 50px !important
    background: #2f4050
    border-bottom-color: #1ab394 !important
    border-bottom-width: 6px !important;
    background-color: #2f4050 !important

    :hover{
        background: #1ab394
    }
    :focus{}
    ${(props) => {
      if (props.loading) {
        return css`
            background-color: #1ab394 !important
                border-bottom-width: 7px !important
            `;
      }
    }}
`;
export const SecondMainButton = styled(Button)`
    min-width: 150px;
    border-radius: 50px !important
    background: white
    border-bottom-color: #12a3ff !important
    border-bottom-width: 6px !important;
    background-color: white !important;
    text-color: #12a3ff

    :hover{
        background: white
    }
    :focus{}
    ${(props) => {
      if (props.loading) {
        return css`
            background-color: white !important
                border-bottom-width: 7px !important
            `;
      }
    }}
`;

export const ButtonYellow = styled(Button)`
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: -19px 33px 55px -16px rgba(197, 202, 224, 1);
  -moz-box-shadow: -19px 33px 55px -16px rgba(197, 202, 224, 1);
  box-shadow: -19px 33px 55px -16px rgba(197, 202, 224, 1);
  margin-bottom: 10px;

  :hover {
    background-color: #ffd700;
    -webkit-box-shadow: 0px 23px 42px -5px rgba(19, 19, 20, 1);
    -moz-box-shadow: 0px 23px 42px -5px rgba(19, 19, 20, 1);
    box-shadow: 0px 23px 42px -5px rgba(19, 19, 20, 1);
  }
`;
export const CardHorizontal = styled.div`
  overflow-x: scroll;
  display: flex;
  flex-direction: row;
`;
export const PlanWrapper = styled.div`
  margin: 5px;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 20px;
  border-radius: 5px;
  ${
    props => {
        let styles = ""
        if(props.selected){
            styles +=` border: 3px solid ${colors.success};`
        }
        if(props.disabled){
            styles +=`opacity: 0.5;`
            styles +=`cursor: not-allowed;`
        }

        return css`${styles}`
    }
  }
  background-color: ${colors.lightBlue};
  min-width: 150px;

  * {
    text-align: center;
    color: white;
    font-weight: bold;
    margin: 0px !important;
  }

  h2 {
    font-size: 20px;
  }
`;
export const Icon = styled.i`
  margin-top: -10px !important;
  color: ${colors.success};
  font-size: 1.8em;
  ${(props) => {
    if (props.selected) {
      return css`
        display: block;
      `;
    } else {
      return css`
        display: none;
      `;
    }
  }}
`;



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/CardUpgrade/components/index.jsx